<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 pt-3">
                <div id="canvas-wrap">
                    <div id="canvas-wrap-2">
                        <canvas height="1280" width="1280"></canvas>
                        <div class="row">
                            <div class="col-6 mb-3">
                                <label class="form-label">Rộng</label>
                                <div class="input-group">
                                    <input type="number" step="1" class="form-control" v-model="canvasWidth">
                                </div>
                            </div>

                            <div class="col-6 mb-3">
                                <label class="form-label">Cao</label>
                                <div class="input-group">
                                    <input type="number" step="1" class="form-control" v-model="canvasHeight">
                                </div>
                            </div>

                            <div class="col-12 mb-3">
                                <label class="form-label">Kiểu hình ảnh</label>
                                <div class="input-group">
                                    <select v-model="fillType" class="form-control">
                                        <option value="0">Căn vừa khung hình</option>
                                        <option value="1">Kéo dãn</option>
                                        <option value="2">Giữ nguyên tỷ lệ</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12">
                                <button class="btn btn-success" v-on:click="processImage"
                                    style="margin-left: 10px;">Lưu</button>
                            </div>
                        </div>
                    </div>
                    <div id="drop-images">

                        <div id="preview-wrap" class="mb-3" style="border: 1px solid black; border-radius: 5px;">

                            <h4 style="border-bottom: 1px solid black; padding-left: 5px; display: flex;">
                                <span style="flex: 1">Danh sách ảnh </span>
                                <input type="file" id="pickImage" multiple v-on:change="loadImages"
                                    style="visibility: hidden;">
                                <label for="pickImage" class="btn btn-sm" style="font-weight: bold;">+</label>
                                <button class="btn btn-sm btn-danger" v-on:click="clearImages"><i
                                        class="fas fa-trash"></i></button>
                            </h4>
                            <div id="preview-images" style="height: 80px;">
                                <img v-on:click="drawItem = img" v-for="img in images" :src="img.src" alt=""
                                    :key="img.fileName">
                            </div>
                        </div>

                        <div id="action-list">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-6">
                                        <div style="border: 1px solid black; border-radius: 5px;">
                                            <h4
                                                style="border-bottom: 1px solid black; height: 34px; padding-left: 5px; display: flex;">
                                                <span style="flex: 1">Danh sách đối tượng</span>
                                                <button class="btn btn-sm" v-on:click="addText"><i
                                                        class="fas fa-text"></i></button>

                                                <label for="select-file" class="btn btn-sm" style="margin-left: 10px;"><i
                                                        class="fas fa-image"></i></label>

                                            </h4>
                                            <div class="padding-top: 10px">

                                                <div v-for="action in actions" :key="action"
                                                    style="border-bottom: 1px dotted black"
                                                    v-on:click="actionSelect = action">
                                                    <div v-if="action.type == 0">
                                                        <div class="row">
                                                            <div class="col-12 mb-3">
                                                                <div class="input-group">
                                                                    <input type="text" class="form-control"
                                                                        v-model="action.text">
                                                                    <button class="btn btn-danger"
                                                                        v-on:click="removeText(action)"><i
                                                                            class="fas fa-trash"></i></button>
                                                                    <button class="btn" type="button"
                                                                        v-on:click="actionSelect = action"><i
                                                                            class="fas fa-edit"></i></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div v-if="action.type == 1">

                                                        <div style="display: flex; width: 100%;">

                                                            <div style="flex: 1">
                                                                <img style="max-width: 40px;" :src="action.src" alt="">
                                                            </div>
                                                            <button class="btn btn-danger"
                                                                v-on:click="removeText(action)"><i
                                                                    class="fas fa-trash"></i></button>
                                                            <button type="button" class="btn"
                                                                v-on:click="actionSelect = action"><i
                                                                    class="fas fa-edit"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div v-if="actionSelect">
                                            <div v-if="actionSelect.type == 0">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-4">
                                                                <label>Text</label>
                                                            </div>
                                                            <div class="col-8">

                                                                <input type="text" v-model="actionSelect.text"
                                                                    class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-4">
                                                                <label>X</label>
                                                            </div>
                                                            <div class="col-8">
                                                                <input type="number" step="1" v-model="actionSelect.x"
                                                                    class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-4">
                                                                <label>Y</label>
                                                            </div>
                                                            <div class="col-8">
                                                                <input type="number" step="1" v-model="actionSelect.y"
                                                                    class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-4">
                                                                <label>Trong suốt</label>
                                                            </div>
                                                            <div class="col-8">
                                                                <input type="number" min="0" max="1" step="0.05"
                                                                    class="form-control" v-model="actionSelect.opacity">
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-4">
                                                                <label>Kiểu chữ</label>
                                                            </div>
                                                            <div class="col-8">
                                                                <select v-model="actionSelect.fontWeight"
                                                                    class="form-control">
                                                                    <option value="normal">Bình thường</option>
                                                                    <option value="bold">In đậm</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-4">
                                                                <label>Kích thước chữ</label>
                                                            </div>
                                                            <div class="col-8">
                                                                <input type="number" min="1" max="200" step="1"
                                                                    class="form-control" v-model="actionSelect.fontSize">
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-4">
                                                                <label>Font</label>
                                                            </div>
                                                            <div class="col-8">
                                                                <select v-model="actionSelect.font" class="form-control">
                                                                    <option :value="font" v-for="font in fonts" :key="font">
                                                                        {{
                                                                            font
                                                                        }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-4">
                                                                <label>Màu chữ</label>
                                                            </div>
                                                            <div class="col-8">
                                                                <input type="color" class="form-control"
                                                                    v-model="actionSelect.color">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-4">
                                                                <label>Viền</label>
                                                            </div>
                                                            <div class="col-8">
                                                                <input type="checkbox" class="form-check-input"
                                                                    v-model="actionSelect.isStroke">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-4">
                                                                <label>Độ dày viền</label>
                                                            </div>
                                                            <div class="col-8">
                                                                <input type="number" class="form-control"
                                                                    v-model="actionSelect.strokeWidth">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-4">
                                                                <label>Màu viền</label>
                                                            </div>
                                                            <div class="col-8">
                                                                <input type="color" class="form-control"
                                                                    v-model="actionSelect.strokeColor">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-4">
                                                                <label>Góc căn</label>
                                                            </div>
                                                            <div class="col-8">
                                                                <select v-model="actionSelect.align" class="form-control">
                                                                    <option value="0">Trái Trên</option>
                                                                    <option value="1">Giữa Trên</option>
                                                                    <option value="2">Phải Trên</option>
                                                                    <option value="3">Trái Giữa</option>
                                                                    <option value="4">Giữa Giữa</option>
                                                                    <option value="5">Phải Giữa</option>
                                                                    <option value="6">Trái Dưới</option>
                                                                    <option value="7">Giữa Dưới</option>
                                                                    <option value="8">Phải Dưới</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div v-if="actionSelect.type == 1">

                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <label>X</label>
                                                        </div>
                                                        <div class="col-8">

                                                            <input type="number" v-model="actionSelect.x"
                                                                class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <label>Y</label>
                                                        </div>
                                                        <div class="col-8">
                                                            <input type="number" step="1" v-model="actionSelect.y"
                                                                class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <label>Rộng</label>
                                                        </div>
                                                        <div class="col-8">

                                                            <input type="number" v-model="actionSelect.width"
                                                                class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <label>Cao</label>
                                                        </div>
                                                        <div class="col-8">
                                                            <input type="number" step="1" v-model="actionSelect.height"
                                                                class="form-control">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <label>Góc căn</label>
                                                        </div>
                                                        <div class="col-8">
                                                            <select v-model="actionSelect.align" class="form-control">
                                                                <option value="0">Trái Trên</option>
                                                                <option value="1">Giữa Trên</option>
                                                                <option value="2">Phải Trên</option>
                                                                <option value="3">Trái Giữa</option>
                                                                <option value="4">Giữa Giữa</option>
                                                                <option value="5">Phải Giữa</option>
                                                                <option value="6">Trái Dưới</option>
                                                                <option value="7">Giữa Dưới</option>
                                                                <option value="8">Phải Dưới</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 pt-5">
                <div class="col-12" style="text-align: left;">
                    <input type="file" id="select-file" style="visibility: hidden;" v-on:change="selectImage($event)">
                    <a href="" id="link"></a>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
const fontCheck = new Set([
    // Windows 10
    'Arial', 'Arial Black', 'Bahnschrift', 'Calibri', 'Cambria', 'Cambria Math', 'Candara', 'Comic Sans MS', 'Consolas', 'Constantia', 'Corbel', 'Courier New', 'Ebrima', 'Franklin Gothic Medium', 'Gabriola', 'Gadugi', 'Georgia', 'HoloLens MDL2 Assets', 'Impact', 'Ink Free', 'Javanese Text', 'Leelawadee UI', 'Lucida Console', 'Lucida Sans Unicode', 'Malgun Gothic', 'Marlett', 'Microsoft Himalaya', 'Microsoft JhengHei', 'Microsoft New Tai Lue', 'Microsoft PhagsPa', 'Microsoft Sans Serif', 'Microsoft Tai Le', 'Microsoft YaHei', 'Microsoft Yi Baiti', 'MingLiU-ExtB', 'Mongolian Baiti', 'MS Gothic', 'MV Boli', 'Myanmar Text', 'Nirmala UI', 'Palatino Linotype', 'Segoe MDL2 Assets', 'Segoe Print', 'Segoe Script', 'Segoe UI', 'Segoe UI Historic', 'Segoe UI Emoji', 'Segoe UI Symbol', 'SimSun', 'Sitka', 'Sylfaen', 'Symbol', 'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana', 'Webdings', 'Wingdings', 'Yu Gothic',
    // macOS
    'American Typewriter', 'Andale Mono', 'Arial', 'Arial Black', 'Arial Narrow', 'Arial Rounded MT Bold', 'Arial Unicode MS', 'Avenir', 'Avenir Next', 'Avenir Next Condensed', 'Baskerville', 'Big Caslon', 'Bodoni 72', 'Bodoni 72 Oldstyle', 'Bodoni 72 Smallcaps', 'Bradley Hand', 'Brush Script MT', 'Chalkboard', 'Chalkboard SE', 'Chalkduster', 'Charter', 'Cochin', 'Comic Sans MS', 'Copperplate', 'Courier', 'Courier New', 'Didot', 'DIN Alternate', 'DIN Condensed', 'Futura', 'Geneva', 'Georgia', 'Gill Sans', 'Helvetica', 'Helvetica Neue', 'Herculanum', 'Hoefler Text', 'Impact', 'Lucida Grande', 'Luminari', 'Marker Felt', 'Menlo', 'Microsoft Sans Serif', 'Monaco', 'Noteworthy', 'Optima', 'Palatino', 'Papyrus', 'Phosphate', 'Rockwell', 'Savoye LET', 'SignPainter', 'Skia', 'Snell Roundhand', 'Tahoma', 'Times', 'Times New Roman', 'Trattatello', 'Trebuchet MS', 'Verdana', 'Zapfino',
].sort());

(async () => {
    await document.fonts.ready;

    const fontAvailable = new Set();

    for (const font of fontCheck.values()) {
        if (document.fonts.check(`12px "${font}"`)) {
            fontAvailable.add(font);
        }
    }
})();
const textAcc = [
    {
        left: 0,
        top: 0,
        leftDirect: 1,
        topDirect: 1,
        canvasTop: 0,
        canvasLeft: 0
    },
    {
        left: 0.5,
        top: 0,
        leftDirect: 1,
        topDirect: 1,
        canvasTop: 0,
        canvasLeft: 0.5
    },
    {
        left: 1,
        top: 0,
        leftDirect: -1,
        topDirect: 1,
        canvasTop: 0,
        canvasLeft: 1
    },
    {
        left: 0,
        top: 0.5,
        leftDirect: 1,
        topDirect: 1,
        canvasTop: 0.5,
        canvasLeft: 0
    },
    {
        left: 0.5,
        top: 0.5,
        leftDirect: 1,
        topDirect: 1,
        canvasTop: 0.5,
        canvasLeft: 0.5
    },
    {
        left: 1,
        top: 0.5,
        leftDirect: 1,
        topDirect: 1,
        canvasTop: 0.5,
        canvasLeft: 1
    },
    {
        left: 0,
        canvasLeft: 0,
        top: 1,
        leftDirect: 1,
        topDirect: -1,
        canvasTop: 1
    },
    {
        left: 0.5,
        canvasLeft: 0.5,
        top: 1,
        leftDirect: 1,
        topDirect: -1,
        canvasTop: 1
    },
    {
        left: 1,
        canvasLeft: 1,
        top: 1,
        leftDirect: -1,
        topDirect: -1,
        canvasTop: 1
    }

]
export default {
    name: 'HinhAnh',
    data() {
        return {
            images: [],
            canvas: null,
            canvasWidth: 1280,
            canvasHeight: 1280,
            fillType: 0,
            ctx: null,
            fonts: [],
            link: null,
            actionSelect: null,
            drawItem: null,
            actions: [
            ]
        }
    },
    async mounted() {
        this.canvas = this.$el.querySelector("canvas");
        this.link = this.$el.querySelector("#link");
        this.ctx = this.canvas.getContext("2d");
        await document.fonts.ready;


        for (const font of fontCheck.values()) {
            if (document.fonts.check(`12px "${font}"`)) {
                this.fonts.push(font);
            }
        }

        let images = localStorage.getItem("images");
        console.log(images);
        if (images != null) {
            this.images = JSON.parse(images);
            console.log(this.images);
        }
        let actions = localStorage.getItem("actions");
        if (actions != null) {
            this.actions = JSON.parse(actions);
        }
    },
    components: {
    },
    watch: {
        canvasWidth(val) {
            this.canvas.width = val;
            if (this.drawItem) {
                this.drawImage(this.drawItem);
            }
        },
        canvasHeight(val) {
            this.canvas.height = val;
            if (this.drawItem) {
                this.drawImage(this.drawItem);
            }
        },
        drawItem(val) {
            this.drawImage(val, true);
        },
        actions: {
            handler: function () {
                if (this.drawItem) {
                    this.drawImage(this.drawItem);
                }
                localStorage.setItem("actions", JSON.stringify(this.actions));
            }, deep: true
        },
        fillType() {
            if (this.drawItem) {
                this.drawImage(this.drawItem);
            }
        }
    },
    methods: {
        clearImages() {
            this.images = [];
            localStorage.setItem("images", "[]");
        },
        removeText(action) {
            this.actions.splice(this.actions.indexOf(action), 1);
        },
        saveImage(fileName) {
            console.log({ fileName });
            var image = this.canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
            this.link.setAttribute("href", image);
            this.link.setAttribute("download", fileName.name + ".png")
            this.link.click();
        },
        async delay(time) {
            return await new Promise(r => {
                setTimeout(function () {
                    r(true);
                }, time)
            })
        },
        async processImage() {
            while (this.images.length > 0) {
                this.drawImage(this.images[0], true);
                await this.delay(100);
                this.saveImage(this.images[0].fileName);
                await this.delay(100);
                this.images.splice(0, 1);

            }
        },
        addText() {
            this.actions.push({
                type: 0,
                x: 0,
                y: 0,
                text: "Hello",
                fontSize: 120,
                font: "Arial",
                color: "#000000",
                fontWeight: "bold",

                isStroke: true,
                strokeColor: "#ffffff",
                strokeWidth: 3,
                opacity: 0.5,
                align: 0,
                toggle: false
            })
        },
        selectImage($event) {
            let t = this;
            console.log($event);
            let file = $event.target.files[0];

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                console.log(reader.result);
                let img = new Image();
                img.onload = function () {
                    t.actions.push({
                        type: 1,
                        x: 0,
                        y: 0,
                        src: reader.result,
                        width: this.width,
                        height: this.height,
                        opacity: 0.5,
                        align: 0,
                        toggle: false
                    })
                };
                img.src = reader.result;
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        },
        async drawImage(obj, clear = false) {
            this.ctx.filter = "none";
            if (clear) {
                this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
            }

            const image = new Image();
            await new Promise(r => {
                image.addEventListener("load", function () {
                    r(true);
                });
                image.src = obj.src;
            })
            const r = image.naturalWidth / image.naturalHeight;
            const r2 = this.canvasWidth / this.canvasHeight;
            this.canvas.width = this.canvasWidth;
            this.canvas.height = this.canvasHeight;
            let wB, hB, wR, hR;
            if (r >= r2) {
                //for blur background
                hB = this.canvasHeight;
                wB = this.canvasHeight * r;

                //for image
                wR = this.canvasWidth;
                hR = this.canvasWidth / r;
            } else {
                wB = this.canvasWidth;
                hB = this.canvasWidth / r;
                hR = this.canvasHeight;
                wR = this.canvasHeight * r;
            }
            if (Number(this.fillType) == 0) {
                this.ctx.filter = "blur(35px)";
                this.ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, (this.canvasWidth - wB) / 2, (this.canvasHeight - hB) / 2, wB, hB);
                this.ctx.filter = "none";
                this.ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, (this.canvasWidth - wR) / 2, (this.canvasHeight - hR) / 2, wR, hR);
            } else if (Number(this.fillType) == 1) {
                this.ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, (this.canvasWidth - wB) / 2, (this.canvasHeight - hB) / 2, wB, hB);
            } else if (Number(this.fillType) == 2) {
                this.canvas.width = wB;
                this.canvas.height = hB;
                this.ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, 0, 0, wB, hB);
            }


            for (let i = 0; i < this.actions.length; i++) {
                this.ctx.filter = "none";
                const action = this.actions[i];
                if (action.type == 0) {
                    this.ctx.filter = "opacity(" + action.opacity + ")"
                    this.ctx.fillStyle = action.color;
                    this.ctx.font = action.fontWeight + " " + action.fontSize.toString() + "px " + action.font;
                    const me = this.ctx.measureText(action.text);
                    const actualHeight = me.actualBoundingBoxAscent + me.actualBoundingBoxDescent;

                    const textAlign = textAcc[Number(action.align)];
                    const textParam = [
                        Number(this.canvas.width) * textAlign.canvasLeft - me.width * textAlign.left + textAlign.leftDirect * action.x,
                        Number(this.canvas.height) * textAlign.canvasTop - actualHeight * textAlign.top + textAlign.topDirect * action.y + actualHeight,
                    ];
                    if (action.isStroke) {
                        this.ctx.lineWidth = action.strokeWidth;
                        this.ctx.strokeStyle = action.strokeColor;

                        this.ctx.strokeText(action.text, ...textParam)
                    }
                    this.ctx.fillText(action.text, ...textParam);

                } else if (action.type == 1) {
                    let imgParam = [];
                    let img = new Image();
                    await new Promise(r => {
                        img.onload = function () {
                            r(true);
                        };
                        img.src = action.src;
                    })
                    switch (Number(action.align)) {
                        case 0:
                            imgParam = [
                                0,
                                0,
                                img.width,
                                img.height,
                                action.x,
                                action.y,
                                action.width,
                                action.height
                            ];
                            break;
                        case 1:
                            imgParam = [
                                0,
                                0,
                                img.width,
                                img.height,
                                (Number(this.canvas.width) - action.width) / 2 + action.x,
                                action.y,
                                action.width,
                                action.height
                            ];
                            break;
                        case 2:
                            imgParam = [
                                0,
                                0,
                                img.width,
                                img.height,
                                (Number(this.canvas.width) - action.width) - action.x,
                                action.y,
                                action.width,
                                action.height
                            ];
                            break;
                        case 3:
                            imgParam = [
                                0,
                                0,
                                img.width,
                                img.height,
                                action.x,
                                (Number(this.canvas.height) - action.height) / 2 + action.y,
                                action.width,
                                action.height
                            ];
                            break;
                        case 4:
                            imgParam = [
                                0,
                                0,
                                img.width,
                                img.height,
                                (Number(this.canvas.width) - action.width) / 2 + action.x,
                                (Number(this.canvas.height) - action.height) / 2 + action.y,
                                action.width,
                                action.height
                            ];
                            break;
                        case 5:
                            imgParam = [
                                0,
                                0,
                                img.width,
                                img.height,
                                (Number(this.canvas.width) - action.width) - action.x,
                                (Number(this.canvas.height) - action.height) / 2 + action.y,
                                action.width,
                                action.height
                            ];
                            break;
                        case 6:
                            imgParam = [
                                0,
                                0,
                                img.width,
                                img.height,
                                action.x,
                                (Number(this.canvas.height) - action.height) - action.y,
                                action.width,
                                action.height
                            ];
                            break;
                        case 7:
                            imgParam = [
                                0,
                                0,
                                img.width,
                                img.height,
                                (Number(this.canvas.width) - action.width) / 2 + action.x,
                                (Number(this.canvas.height) - action.height) - action.y,
                                action.width,
                                action.height
                            ];
                            break;
                        case 8:
                            imgParam = [
                                0,
                                0,
                                img.width,
                                img.height,
                                (Number(this.canvas.width) - action.width) - action.x,
                                (Number(this.canvas.height) - action.height) - action.y,
                                action.width,
                                action.height
                            ];
                            break;
                    }
                    console.log(imgParam);
                    this.ctx.drawImage(img, ...imgParam);
                }
            }
        },
        async loadImages(ee) {
            var input = ee.target;
            const t = this;
            if (input.files && input.files.length > 0) {
                for (let i = 0; i < input.files.length; i++) {
                    await new Promise(r => {
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            t.images.push({
                                fileName: input.files[i],
                                src: e.target.result
                            });
                            r(true);
                        }
                        reader.readAsDataURL(input.files[i]);
                    })
                }
            }
            localStorage.setItem("images", JSON.stringify(t.images));
        }
    }
}
</script>
  
<style lang="less">
canvas {
    max-width: 300px;
    width: 100%;
    border: 1px solid #ccc;
}

#drop-images {
    flex: 1;
    text-align: left;
    padding-left: 20px;
}

#canvas-wrap-2 {
    max-width: 300px;
    width: 100%;

}

#canvas-wrap {
    display: flex;
    flex-wrap: wrap;

}

#preview-images {
    img {
        max-width: 50px;
        max-height: 50px;
        margin-right: 5px;
        margin-bottom: 5px;
    }
}
</style>
  